import { injectable } from 'inversify';

export interface IGISTODARApiClient {

}

@injectable()
export class GISTODARApiClient implements IGISTODARApiClient {
    
}